import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import './Volunteer_Card.css'
import { Link } from "react-router-dom";
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";

const Volunteer_Card = ({ item }) => {
  return (
    <Link to={`/volunteer-details/${encodeId(item.id)}`}>
      <div className="Volunteer_Card">
        <div className="card_img_holder">
          <img src={`${IDS.IMG_URL}${item?.image}`} className="image" />
        </div>

        <div className="overlay_color"></div>

        <div className="text_holder">
          <p className="title_text">{item?.name}</p>
          <p className="sub_text">{item?.subname}</p>
        </div>
      </div>
    </Link>
  );
};

export default Volunteer_Card;

